import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const IdleEmail = (props) => {
  const { t } = useTranslation();
  const [play, setPlay] = useState(false);
  const machineID = localStorage.getItem('machineID');
  const linkToURL = `/machineUI/home/${machineID}/`;
  const { sendOrder } = props;
  let history = useHistory();
  const handleOnIdle = (event) => {
    console.log('idle');
    setPlay(false);
    if (props.go) {
      if (sendOrder) {
        sendOrder();
      }

      console.log('gopage');
      history.push(linkToURL + 'false');
    }
  };

  const handleOnIdle1 = (event) => {
    setPlay(true);
  };

  const handleOnActive1 = (event) => {
    setTimeout(() => {
      setPlay(false);
    }, 100);
  };

  const handleOnAction1 = (event) => {
    setTimeout(() => {
      setPlay(false);
    }, 100);
  };

  const idletimer = useIdleTimer({
    startManually: true,
    timeout: 30000,
    onIdle: handleOnIdle,
    // onActive: handleOnActive,
    // onAction: handleOnAction,
    debounce: 500,
  });
  const idletimer1 = useIdleTimer({
    startManually: true,
    timeout: 15000,
    onIdle: handleOnIdle1,
    onActive: handleOnActive1,
    onAction: handleOnAction1,
    debounce: 500,
  });

  useEffect(() => {
    if (props.go) {
      console.log('start');
      idletimer.start();
      idletimer1.start();
    }
  }, [props.go]);

  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return;
    }

    return (
      <div className="countdowntext">
        <div>{t(`Timeout In`)}</div>
        <div>{remainingTime}</div>
        <div>{t(`Seconds`)}</div>
      </div>
    );
  };

  useEffect(() => {
    const timeoutId = document.querySelector('#timeoutId');
    if (timeoutId)
      timeoutId.addEventListener('click', (event) => {
        event.preventDefault();
      });
  }, [play]);

  if (!play || !props.go) {
    return null;
  } else {
    return (
      <div className="privacy-modal-container" id="timeoutId">
        <div className="countdown">
          <CountdownCircleTimer
            isPlaying={play}
            size={600}
            duration={15}
            strokeWidth={20}
            colors={['#004777', '#F7B801', '#A30000', '#A30000']}
            colorsTime={[10, 6, 3, 0]}
          >
            {renderTime}
          </CountdownCircleTimer>
        </div>
      </div>
    );
  }
};

export default IdleEmail;
